/* RESPONSIBLE TEAM: team-ai-agent */
import EmbercomBaseSerializer from './base/embercom-base-serializer';

export default class CopilotSettingsSerializer extends EmbercomBaseSerializer {}
